import boxTypes from './constants/boxTypes';
import iconTypes from './constants/iconTypes';
import paths from './paths';

export const BOX_TYPES = boxTypes;
export const ICON_TYPES = iconTypes;
export const PATHS = paths;
